import React, { useState } from "react";
import { LogOut, MapPinned } from "lucide-react";
import { ACTIVE_AREA, getAreas, switchArea, createArea } from "../data/rssbData";
import { logout } from "../lib/auth";
import { hinglishToHindi } from "../lib/translit";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { HindiInput } from "./HindiInput";

const NEW = "__new__";

const AddAreaDialog = ({ open, onClose }) => {
  const [name, setName] = useState("");
  const create = async () => {
    const hi = (await hinglishToHindi(name.trim())).trim();
    if (hi) createArea(hi);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#fffdf7] border-[#6e1b1b]/40 text-[#3a1212]" data-testid="add-area-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-dev">नया क्षेत्र जोड़ें</DialogTitle>
          <DialogDescription className="text-xs text-[#7a4a3a] font-dev">
            क्षेत्र का नाम लिखें। फिर "क्षेत्र सेटअप" टैब में सत्संग घर, पाठी व SR/SK जोड़ें या Excel अपलोड करें।
          </DialogDescription>
        </DialogHeader>
        <HindiInput testid="new-area-name" value={name} onChange={setName} placeholder="e.g. Gola Gokarannath" className="bg-[#f6eeda] border-[#e3d6b6] font-dev" />
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={onClose} className="text-[#5a2a24]">रद्द करें</Button>
          <Button data-testid="new-area-create" disabled={!name.trim()} onClick={create} className="bg-[#6e1b1b] text-[#f3ead6] hover:bg-[#7a1f1f]">
            बनाएं
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

const AreaSwitch = () => {
  const [adding, setAdding] = useState(false);
  return (
    <div className="flex items-center gap-1.5 bg-[#431010] border border-[#f3ead6]/30 rounded-md px-2 py-1">
      <MapPinned className="w-4 h-4 text-[#e7c9a0] shrink-0" />
      <select
        data-testid="area-select"
        value={ACTIVE_AREA}
        onChange={(e) => (e.target.value === NEW ? setAdding(true) : switchArea(e.target.value))}
        className="bg-transparent text-[#f3ead6] text-xs sm:text-sm font-dev font-semibold outline-none max-w-[130px] sm:max-w-[200px]"
      >
        {getAreas().map((a) => (
          <option key={a.id} value={a.id} className="text-[#3a1212]">{a.nameHi}</option>
        ))}
        <option value={NEW} className="text-[#3a1212]">+ नया क्षेत्र जोड़ें</option>
      </select>
      <AddAreaDialog open={adding} onClose={() => setAdding(false)} />
    </div>
  );
};

export const Header = () => (
  <header className="sticky top-0 z-40 bg-[#5e1414] border-b-4 border-[#7a1f1f] shadow-[0_6px_20px_rgba(46,11,11,0.5)]">
    <div className="max-w-[1600px] mx-auto px-3 sm:px-4 py-2.5 flex items-center gap-3">
      <div
        className="shrink-0 w-11 h-11 sm:w-12 sm:h-12 grid place-items-center leading-none font-cinzel font-extrabold text-[#5e1414] bg-[#f3ead6] border-2 border-[#f3ead6] rounded-md shadow-[0_2px_8px_rgba(0,0,0,0.3),inset_0_1px_0_rgba(255,255,255,0.6)] text-base"
        data-testid="app-logo"
      >
        <span>RS</span>
        <span>SB</span>
      </div>
      <div className="min-w-0 hidden sm:block">
        <h1 className="font-cinzel text-base sm:text-[26px] font-extrabold text-[#f7efdc] truncate drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)] uppercase">
          Radha Soami Satsang Beas
        </h1>
        <p className="text-[11px] sm:text-sm text-[#e7d4b4] font-dev truncate">सत्संग शेड्यूल प्लानर</p>
      </div>
      <div className="ml-auto flex items-center gap-2">
        <AreaSwitch />
        <div className="flex flex-col items-end gap-0.5">
          <button
            data-testid="logout-btn"
            onClick={logout}
            title="लॉगआउट"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs sm:text-sm font-semibold text-[#f3ead6] bg-[#7a1f1f] border border-[#f3ead6]/30 hover:bg-[#8a2525] transition-colors font-dev"
          >
            <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">लॉगआउट</span>
          </button>
          <span data-testid="developer-id" className="text-[9px] leading-none font-mono text-[#e7c9a0]/80 whitespace-nowrap">
            Developer ID: Sukhjinder-USA
          </span>
        </div>
      </div>
    </div>
  </header>
);
